import { transit } from '../../util/sdkLoader';
import { apiBaseUrl, typeHandlers } from '../../util/api';
import { isLocalhost } from '../../util/urlHelpers';

/**
 * Requests to the server's own /api/landingpages/* routes.
 *
 * During SSR the API runs in the same Node process. Calling it through the public domain
 * (apiBaseUrl) sends every request out through DNS and Cloudflare and back - up to 10 per
 * rendered landing page - so on the server it is called over loopback instead.
 * The port is fixed: the bundle only inlines REACT_APP_* variables, so process.env.PORT is
 * not available here. It must match the server's port (DigitalOcean HTTP port).
 */
const SSR_API_BASE_URL = 'http://127.0.0.1:8080';

const baseUrl = () =>
    typeof window === 'undefined' && !isLocalhost() ? SSR_API_BASE_URL : apiBaseUrl();

// Resolves to the fetch Response, or to { error, message } if the request itself failed
const get = path =>
    fetch(`${baseUrl()}${path}`).catch(e => ({
        error: true,
        message: e.message || 'fetch.get call failed',
    }));

export const getDynamicLpsCity = async ({ country, canton, city }) =>
    get(`/api/landingpages/${country}/${canton}/${city}`);

export const getDynamicLpsCanton = async ({ country, canton }) =>
    get(`/api/landingpages/${country}/${canton}`);

export const getDynamicLpsCantons = async ({ country, canton }) =>
    canton
        ? get(`/api/landingpages/${country}/cantons?exclude=${canton}`)
        : get(`/api/landingpages/${country}/cantons`);

export const getDynamicLpsNearby = async ({ country, city }) =>
    get(`/api/landingpages/${country}/${city}/nearby`);

export const getDynamicLpsLocations = async ({ canton }) =>
    get(`/api/landingpages/canton/${canton}/locations`);

/**
 * Server-cached anonymous listings/query. Resolves to the same shape as sdk.listings.query
 * (Transit keeps UUID, Money and LatLng typed), or to null if the request failed
 */
export const queryLandingPagesListings = async params => {
    try {
        const res = await fetch(`${baseUrl()}/api/landingpages/listings/query`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params),
        });
        const contentType = res.headers.get('Content-Type') || '';

        if (!res.ok || !contentType.startsWith('application/transit+json')) return null;

        return transit.read(await res.text(), { typeHandlers });
    } catch (e) {
        return null;
    }
};
